import { action, computed, observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PubSub from 'pubsub-js';
import { User, userStatusService } from 'domain/index';
import $ from 'jquery';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';
import {
    HttpPromiseState
    , ReactNodeGenerator
    , GuessServerTime
    , dateFormat
} from 'lib/helpers';
import { TeacherScheduleClassroomResponse } from 'domain/models/response-model';
import { ClassroomLoaders } from 'scenes/classroom/stores/classroom-loaders';
import { Helmet, HelmetTags } from "react-helmet";
import moment from 'moment';

class Store {

}

type Props = {

}

type State = {
    isOpen: boolean;
    TeacherName: string;
    Monday: string;
    Tuesday: string;
    Wednesday: string;
    Thursday: string;
    Friday: string;
    Saturday: string;
    Sunday: string;
}

const SCHEDULER_ID = "TeacherScheduler";

export class TeacherScheduleModal extends React.Component<Props, State> {

    timezone: string = 'Etc/UTC';

    SchedulerId: string = "";

    serverTime: GuessServerTime = new GuessServerTime();

    private token: string | null = null;
    state = {
        isOpen: false,
        TeacherName: 'Empty',
        Monday: '',
        Tuesday: '',
        Wednesday: '',
        Thursday: '',
        Friday: '',
        Saturday: '',
        Sunday: '',
    };

    closeModal = () => {
        this.setState({ isOpen: false });
    }

    constructor(props: Props) {
        super(props);
    }

    onModalClosed() {
        var scheduler = $("#" + SCHEDULER_ID).data("kendoScheduler");
        if (scheduler) {
            scheduler.destroy();
        }
    }

    *renderer(): ReactNodeGenerator {
        yield (
            <Helmet key="Helmet">
                <script id="classroom-template-agenda" type="text/x-kendo-template" key="ScriptEventTemplateAgenda">
                    {
                        `<div class="clasroom-template-agenda">
                  <p>Student: #: studentName #</p>
                  <p>#: title #</p>
                  <p>Status: #: status #</p>
                  #if (data.suggestLabel) {#
                    <p>#= suggestLabel #</p>
                  #}#
                </div>`
                    }
                </script>
                <script id="classroom-template" type="text/x-kendo-template" key="ScriptEventTemplate">
                    {
                        `<div className="clasroom-template">
                  <p>#: studentName #. #: title #</p>
                </div>`
                    }
                </script>
                <script id="event-time-template" type="text/x-kendo-template">
                    {
                        `#= kendo.toString(start, "t") # - #= kendo.toString(endUser, "t") #
                        `
                    }
                </script>
            </Helmet>
        );

        yield (
            <Modal isOpen={this.state.isOpen}
                size="lg"
                style={{ maxWidth: '90%', width: '100%' }}
                centered
                onClosed={this.onModalClosed}>
                <ModalHeader>
                    <div>Teacher - {this.state.TeacherName}</div>
                </ModalHeader>
                <ModalBody>
                    <div>
                        <p>Monday: {this.state.Monday}</p>
                        <p>Tuesday: {this.state.Tuesday}</p>
                        <p>Wednesday: {this.state.Wednesday}</p>
                        <p>Thursday: {this.state.Thursday}</p>
                        <p>Friday: {this.state.Friday}</p>
                        <p>Saturday: {this.state.Saturday}</p>
                        <p>Sunday: {this.state.Sunday}</p>
                    </div>
                    <div id={SCHEDULER_ID}></div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary"
                        onClick={this.closeModal} value="test">Close
                    </button>
                </ModalFooter>
            </Modal>);
    }

    render() {
        return Array.from(this.renderer());
    }

    mySubscriber = (msg: any, data: User) => {
        const teacherId = data.Id;
        this.setState({ isOpen: true });
        const self = this;
        const httpState = ClassroomLoaders.Teacher.getClassroomSchedule(teacherId);
        $("#" + SCHEDULER_ID).kendoScheduler({
            add: (e) => {
                e.preventDefault();
            },
            edit: (e) => {
                e.preventDefault();
            },
            move: (e) => {
                e.preventDefault();
            },
            remove: (e) => {
                e.preventDefault();
            },
            resize: (e) => {
                e.preventDefault();
            },
            moveStart: (e) => {
                e.preventDefault();
            },
            resizeStart: (e) => {
                e.preventDefault();
            },
            allDaySlot: false,
            currentTimeMarker: false,
            footer: false,
            date: this.serverTime.nowMoment.toDate(),
            height: 600,
            views: [
                {
                    type: "agenda",
                    selected: true,
                    eventTemplate: $("#classroom-template-agenda").html(),
                    eventTimeTemplate: $("#event-time-template").html(),
                },
                { type: "day" },
                { type: "week" },
                { type: "month" }
            ],
            dataSource: {
                batch: true,
                transport: {
                    read: function (options: any) {
                        reaction(() => httpState.value, () => {
                            var respVal = httpState.value!;
                            self.setState({
                                TeacherName: respVal.TeacherName,
                                Monday: respVal.Monday,
                                Tuesday: respVal.Tuesday,
                                Wednesday: respVal.Wednesday,
                                Thursday: respVal.Thursday,
                                Friday: respVal.Friday,
                                Saturday: respVal.Saturday,
                                Sunday: respVal.Sunday,
                            })
                            options.success(httpState.value);
                        });
                    },
                    update: (options: any) => {
                        options.success(null);
                    },
                    create: (options: any) => {
                        options.success(null);
                    }
                },
                schema: {
                    data: "Events",
                    model: {
                        id: "taskId",
                        fields: {
                            taskId: { from: "ClassRoomId", type: "number" },
                            title: { from: "Title", defaultValue: "No title", validation: { required: true } },
                            start: { type: "date", from: "StartDate" },
                            end: { type: "date", from: "EndDate" },
                            endUser: { type: "date", from: "EndDateUser" },
                            startTimezone: { from: "StartTimezone" },
                            endTimezone: { from: "EndTimezone" },
                            teacherId: { from: "TeacherId" },
                            teacherName: { from: "TeacherName" },
                            studentId: { from: "StudentId" },
                            studentName: { from: "StudentName" },
                            status: { from: "Status" },
                            suggestionStartTime: { from: "SuggestionStartTime" },
                            suggestionUserId: { from: "SuggestionUserId" },
                            suggestionStartTimeFormatted: { from: "SuggestionStartTimeFormatted" },
                            showSuggestButton_Computed: { from: "ShowSuggestButton_Computed" },
                            showApproveButton_Computed: { from: "ShowApproveButton_Computed" },
                            showStartButton_Computed: { from: "ShowStartButton_Computed" },
                            showEditLessonButton_Computed: { from: "ShowEditLessonButton_Computed" },
                            suggestLabel: { from: "SuggestLabel" },
                        }
                    },
                    parse: (data: TeacherScheduleClassroomResponse) => {
                        $.each(data.Events, (i, classroom) => {
                            const classroomAny: any = classroom;
                            let bResult: boolean;
                            classroomAny.SuggestionStartTimeFormatted = dateFormat(classroom.SuggestionStartTime, 'wymdhm', true);
                            // showSuggestButton
                            bResult = classroom.Status === 'Scheduled'
                                && !classroom.SuggestionStartTime
                                && classroom.SuggestionApproveUserId == null;
                            classroomAny.ShowSuggestButton_Computed = bResult;
                            // showApproveButton
                            bResult = classroom.Status === 'Scheduled'
                                && classroom.SuggestionStartTime != null
                                && classroom.SuggestionUserId != null
                                && classroom.TeacherId != classroom.SuggestionUserId
                                && classroom.SuggestionApproveUserId == null;
                            classroomAny.ShowApproveButton_Computed = bResult;
                            // showStartButton
                            bResult = classroom.Status === 'InProgress';
                            classroomAny.ShowStartButton_Computed = bResult;
                            // suggestLabel Start
                            let suggestLabel: string | null = null;
                            const hasSuggestion = classroom.Status === 'Scheduled'
                                && classroom.SuggestionStartTime != null
                                && classroom.SuggestionUserId != null;
                            if (hasSuggestion) {
                                if (classroom.SuggestionApproveUserId == null) {
                                    suggestLabel = "Change time suggested: "
                                        + dateFormat(classroom.SuggestionStartTime, 'wymdhm', true)
                                        + ' . Wating approval.';
                                }
                                else {
                                    const newTime = dateFormat(classroom.ScheduledStartTime, 'wymdhm', true);
                                    const oldTime = dateFormat(classroom.SuggestionApproveOldTime, 'wymdhm', true);
                                    suggestLabel = `Change time approved. New time: ${newTime}. Old time: ${oldTime}`;
                                }
                            }
                            classroomAny.SuggestLabel = suggestLabel;
                            // suggestLabel End
                            classroomAny.StartDate = moment.utc(classroom.Start).toDate();
                            classroomAny.EndDateUser = moment.utc(classroom.End).toDate();
                            let startDay = moment.utc(classroom.Start).toDate().getDay();
                            let endDay = moment.utc(classroom.End).toDate().getDay();
                            if(startDay!=endDay){
                            //if lesson is between 2 days, we must set lesson end time to end of the starting day 11:59
                            classroomAny.EndDate = moment.utc(moment.utc(classroom.Start).set('minute', 59)).toDate();
                            }
                            else{
                            classroomAny.EndDate = moment.utc(classroom.End).toDate();
                            }
                            // showEditLessonButton
                            classroomAny.ShowEditLessonButton_Computed = classroom.Status === 'Scheduled';
                        });
                        return data;
                    }
                },
            },
            resources: [
                {
                    field: "ownerId",
                    title: "Owner",
                    dataSource: [
                        { text: "Alex", value: 1, color: "#f8a398" },
                        { text: "Bob", value: 2, color: "#51a0ed" },
                        { text: "Charlie", value: 3, color: "#56ca85" }
                    ]
                }
            ]
        });
    }

    componentDidMount() {
        this.token = PubSub.subscribe("OpenTeacherModal", this.mySubscriber);
        this.timezone = userStatusService.status.user?.TimeZone?.Name ?? 'Etc/UTC';
    }

    componentWillUnmount() {
        if (this.token) {
            PubSub.unsubscribe(this.token);
        }
        var scheduler = $("#" + SCHEDULER_ID).data("kendoScheduler");
        if (scheduler) {
            scheduler.destroy();
        }
    }
}